import React from "react";
import { Flex, Text, Link } from "@chakra-ui/react";
import { APP_NAME, FOOTER_URL } from "../config/runtime";

const version = process.env.REACT_APP_VERSION || "";
const year = new Date().getFullYear();

const Footer = () => {
  return (
    <Flex
      as="footer"
      justify="center"
      align="center"
      position="fixed"
      bottom="0"
      width="100%"
      h="36px"
      bg="white"
      color="gray.600"
      borderTop="1px solid"
      borderColor="gray.200"
    >
      <Text fontSize="sm" opacity={1}>
        © {year} {APP_NAME} v{version} —{" "}
        <Link href={FOOTER_URL} isExternal color="indigo.600" _hover={{ opacity: 1 }}>
          threatmodeling.studio
        </Link>
      </Text>
    </Flex>
  );
};

export default Footer;